// src/App.jsx
import React, { useState, useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { TraumatoCatalogProvider } from "./context/TraumatoCatalogContext.jsx";

import toast, { Toaster } from "react-hot-toast";
import { socket } from "./socket";
import { CONFIG } from "./config/config";
import { mapDbPatient } from "./utils/patientHelpers";

function getInitialPatients() {
  try {
    return JSON.parse(localStorage.getItem("patients")) || [];
  } catch {
    return [];
  }
}

export default function App() {
  const [patients, setPatients] = useState(getInitialPatients());

  useEffect(() => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) return;
    fetch(`${CONFIG.API_URL}/passages`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((list) => setPatients(list.map(mapDbPatient)))
      .catch(console.error);
  }, []);

  // 🔔 Message global (ex: "✅ Patient importé via PDF" / "via APICRYPT")
  useEffect(() => {
    const onInfo = (payload) => {
      const show =
        payload?.kind === "error"
          ? toast.error
          : payload?.kind === "success"
            ? toast.success
            : toast;
      show(payload?.message || "Info");
    };
    socket.on("info", onInfo);
    return () => socket.off("info", onInfo);
  }, []);

  return (
    <>
      <TraumatoCatalogProvider>
        <AppRoutes patients={patients} setPatients={setPatients} />
      </TraumatoCatalogProvider>
      <Toaster position="bottom-center" toastOptions={{ duration: 1800 }} />
    </>
  );
}
